import { useGetQuery } from '../../graphql';
import { Product } from '../domain';

export const useProduct = (productId: string) => {
  const { data, isLoading, invalidateQuery, refetch } = useGetQuery({
    modelName: 'product',
    query: FIND_PRODUCT,
    id: productId,
    options: { enabled: !!productId },
  });

  return {
    product: data as Product,
    isLoading,
    invalidateQuery,
    refetch,
  };
};

const FIND_PRODUCT = `
  query FindProduct($id: ID!) {
    getProduct(id: $id) {
      id
      name
      description
      details
      specifications
      coverImage {
        id
        name
        extension
        status
        type
        url
        createdAt
        updatedAt
      }
      addons {
        id
        name
      }
      routines {
        id
        name
        order
        type
        config
        deactivated
        currentVersion {
          id
        }
      }
      media {
        id
        name
        extension
        status
        type
        url
        createdAt
        updatedAt
        updatedBy {
          id
          name {
            first
            last
          }
        }
        createdBy {
          id
          name {
            first
            last
          }
        }
        categories {
          id
          name
        }
      }
    }
  }
`;
